import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import NotificationHandler from './components/NotificationHandler';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ClientDashboard from './pages/ClientDashboard';
import ClientLayout from './pages/ClientLayout';
import ClientLogin from './pages/ClientLogin';
import ClientMessagesPage from './pages/ClientMessagesPage';
import ClientNutritionPage from './pages/ClientNutritionPage';
import ClientRegister from './pages/ClientRegister';
import ClientSettingsPage from './pages/ClientSettingsPage';
import ClientWeightPage from './pages/ClientWeightPage';
import ContactPage from './pages/ContactPage';
import ContentManagementPage from './pages/ContentManagementPage';
import DietitianAppointmentDetailPage from './pages/DietitianAppointmentDetailPage';
import DietitianAppointmentsPage from './pages/DietitianAppointmentsPage';
import DietitianAutomatedMessagesPage from './pages/DietitianAutomatedMessagesPage';
import DietitianClientDetailPage from './pages/DietitianClientDetailPage';
import DietitianClientRequestsPage from './pages/DietitianClientRequestsPage';
import DietitianClientsPage from './pages/DietitianClientsPage';
import DietitianDashboard from './pages/DietitianDashboard';
import DietitianLayout from './pages/DietitianLayout';
import DietitianLogin from './pages/DietitianLogin';
import DietitianMessagesPage from './pages/DietitianMessagesPage';
import DietitianProgramDetailPage from './pages/DietitianProgramDetailPage';
import DietitianProgramsPage from './pages/DietitianProgramsPage';
import DietitianRegister from './pages/DietitianRegister';
import DietitianSettingsPage from './pages/DietitianSettingsPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import MyDietitianPage from './pages/MyDietitianPage';
import MyDietitianSettingsPage from './pages/MyDietitianSettingsPage';
import PostDetailPage from './pages/PostDetailPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SelectDietitianPage from './pages/SelectDietitianPage';
import SetPasswordPage from './pages/SetPasswordPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PublicFeedPage from './pages/PublicFeedPage';
import WelcomePage from './pages/WelcomePage';

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Router>
          <NotificationHandler />
          <ScrollToTop />
          <div className="App">
            <Routes>
              <Route path="/" element={<WelcomePage />} />
              <Route path="/dietitian/login" element={<DietitianLogin />} />
              <Route path="/dietitian/register" element={<DietitianRegister />} />
              <Route path="/dietitian/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/dietitian/reset-password" element={<ResetPasswordPage />} />
              <Route path="/client/login" element={<ClientLogin />} />
              <Route path="/client/register" element={<ClientRegister />} />
              <Route path="/client/set-password" element={<SetPasswordPage />} />
              <Route path="/client/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/client/reset-password" element={<ResetPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/feed" element={<PublicFeedPage />} />
              <Route path="/feed/:id" element={<PostDetailPage />} />

              {/* Dietitian Routes with Layout */}
              <Route path="/dietitian" element={<DietitianLayout />}>
                <Route index element={<DietitianDashboard />} />
                <Route path="clients" element={<DietitianClientsPage />} />
                <Route
                  path="clients/:clientId"
                  element={<DietitianClientDetailPage />}
                />
                <Route
                  path="appointments"
                  element={<DietitianAppointmentsPage />}
                />
                <Route
                  path="appointments/:appointmentId"
                  element={<DietitianAppointmentDetailPage />}
                />
                <Route path="programs" element={<DietitianProgramsPage />} />
                <Route
                  path="programs/:programId"
                  element={<DietitianProgramDetailPage />}
                />
                <Route path="messages" element={<DietitianMessagesPage />} />
                <Route path="automated-messages" element={<DietitianAutomatedMessagesPage />} />
                <Route path="client-requests" element={<DietitianClientRequestsPage />} />
                <Route path="content" element={<ContentManagementPage />} />
                <Route path="settings" element={<DietitianSettingsPage />} />
              </Route>

              {/* Client Routes with Layout */}
              <Route path="/client" element={<ClientLayout />}>
                <Route index element={<ClientDashboard />} />
                <Route path="messages" element={<ClientMessagesPage />} />
                <Route path="nutrition" element={<ClientNutritionPage />} />
                <Route path="weight" element={<ClientWeightPage />} />
                <Route path="my-dietitian" element={<MyDietitianPage />} />
                <Route
                  path="my-dietitian-settings"
                  element={<MyDietitianSettingsPage />}
                />
                <Route
                  path="select-dietitian"
                  element={<SelectDietitianPage />}
                />
                <Route path="settings" element={<ClientSettingsPage />} />
              </Route>
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
